"use client";

import { LinkProvider } from "@fanduel/og-fe-library";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import Link from "next/link";
import { PropsWithChildren } from "react";
import Rum from "@/components/Rum";
import MSWProvider from "@/tests/testUtils/MSWProvider";
import { AmplitudeProvider } from "@/utils/hooks/useAmplitude";
import FormationProvider from "./FormationProvider";
import QueryClientProvider from "./QueryClientProvider";

const Providers = ({ children }: PropsWithChildren) => (
  <QueryClientProvider>
    <FormationProvider>
      <MSWProvider>
        <Rum />
        <AmplitudeProvider>
          <LinkProvider CustomLink={Link}>{children}</LinkProvider>
        </AmplitudeProvider>
      </MSWProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </FormationProvider>
  </QueryClientProvider>
);

export default Providers;
